__turbopack_context__.v({
  "container": "FfqeCG_container",
  "isActive": "FfqeCG_isActive",
  "tab": "FfqeCG_tab",
});
